<template>
  <div class="flex flex-col mt-4">
    <div class="flex flex-col justify-between items-center">
      <div class="flex flex-col w-full text-center items-center">
        <div class="flex flex-col w-full" />
        <div
          class="flex text-center items-center w-full mt-3"
          :class="insider.status === 'Reviderad' ? 'text-gray-400 dark:text-custom-purple-300' : ''"
        >
          <div class="flex flex-col justify-center mr-2">
            <div
              class="flex w-12 h-12 bg-white flex-shrink-0 justify-center items-center rounded-2xl"
              :class="insider.status === 'Reviderad' ? 'dark:bg-gray-400  dark:text-custom-purple-100' : 'text-custom-purple-500 dark:text-custom-dark-header'"
            >
              <Icon
                :name="icon"
                class="text-2xl mt-1"
                :class="iconTypeClass"
              />
            </div>
            <p class="text-xs mt-1 dark:text-custom-purple-100">
              {{ insider.type }}
            </p>
            <p class="text-3xs mt-1 dark:text-custom-purple-100">
              <template v-if="insider.status === 'Reviderad'">
                (Reviderad)
              </template>
            </p>
          </div>
          <div class="text-xs text-left flex flex-col justify-center flex-shrink-0 pl-2 dark:text-custom-purple-100">
            <p class="text-sm font-semibold">
              {{ insider.person }}
            </p>
            <p
              class="text-xs font-semibold"
            >
              ({{ insider.occupation.indexOf('Annan') > -1 ? 'Annan' : insider.occupation }})
            </p>
            <p class="text-sm">
              {{ publishDate }}
            </p>
            <p
              class="font-medium mt-2"
              :class="[typeClass, positive ? 'dark:text-custom-green-500' : '']"
            >
              {{ insider.price }} {{ insider.currency }}
            </p>
            <p class="font-medium text-sm dark:text-custom-purple-100">
              {{ insider.volume_unit }}: {{ parseFloat(insider.volume).toLocaleString('en-US', {maximumFractionDigits: 2}).replace(/,/g, ' ') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InsiderTradeBig',
  props: {
    insider: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: 'coin-stack'
    },
    typeClass: {
      type: String,
      default: 'text-gray-500'
    },
    iconTypeClass: {
      type: String,
      default: 'text-gray-500'
    },
    positive: {
      type: Boolean,
      default: false
    },
    companyName: {
      type: String,
      default: ''
    },
    companyId: {
      type: Number,
      default: 0
    },
    publishDate: {
      type: String,
      default: ''
    }
  }
}
</script>
